import {
  TRIGGER_CREATE, TRIGGER_EDIT, REQUEST_USER_SUCCESS, UPDATE_INFORMERS, UPDATE_COUNTERS, UPDATE_AGGREGATION_PARAMS, UPDATE_AGGREGATION_PARAMS_2
} from './actions';

const initialState = {
  createopen: false,
  editopen: false,
  currentpage: '',
  user: null,
  data: [],
  refreshToken: Math.random(),
  reduxFormUpdateToken: Math.random(),
  companies: [],
  users: [],
  callcenters: [],
  plans: [],
  tableCounters: [],
  aggregationParams: {
    count: 0, verified: 0, visited: 0, treaty: 0, balance: 0, payments: 0, sum: 0
  },
  aggregationParams2: {
    visited: 0, balance: 0, payments: 0, sum: 0
  },
};

export default (previousState = initialState, { type, payload }) => {
  // console.log(type);
  switch (type) {
    case TRIGGER_CREATE:
      return { ...previousState, createopen: payload };
    case TRIGGER_EDIT:
      return { ...previousState, editopen: payload };
    case REQUEST_USER_SUCCESS:
      return { ...previousState, user: payload };
    // case 'RA/CRUD_GET_LIST_SUCCESS':
    //   return { ...previousState, data: payload.data };
    case 'RA/REFRESH_VIEW':
      return { ...previousState, refreshToken: Math.random() };
    case UPDATE_INFORMERS:
      return {
        ...previousState, companies: payload.companies, plans: payload.plans, city: payload.city, subjects: payload.subjects, users: payload.users, callcenters: payload.callcenters,
      };
    case UPDATE_COUNTERS:
      return {
        ...previousState, tableCounters: payload
      };
    case UPDATE_AGGREGATION_PARAMS:
      return {
        ...previousState, aggregationParams: payload
      };
    case UPDATE_AGGREGATION_PARAMS_2:
      return {
        ...previousState, aggregationParams2: payload
      };
    case '@@router/LOCATION_CHANGE':
      return { ...previousState, currentpage: payload.pathname.replace('/', '') };
    case '@@redux-form/CHANGE':
      return { ...previousState, reduxFormUpdateToken: Math.random() };
    default:
      return previousState;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js